export type CharacterAppearanceProgressionSlot = "form" | "hair" | "robes" | "relic" | "scene";

export const CHARACTER_APPEARANCE_TIER_LEVELS = {
  first: 1,
  second: 10,
  complete: 15,
} as const;

export const CHARACTER_APPEARANCE_UNLOCK_LEVELS = {
  form: { harbour: CHARACTER_APPEARANCE_TIER_LEVELS.first, wayfinder: CHARACTER_APPEARANCE_TIER_LEVELS.second, sentinel: CHARACTER_APPEARANCE_TIER_LEVELS.complete },
  hair: { portrait: CHARACTER_APPEARANCE_TIER_LEVELS.first, "tide-knot": CHARACTER_APPEARANCE_TIER_LEVELS.second, windswept: CHARACTER_APPEARANCE_TIER_LEVELS.complete },
  robes: { "coastal-blue": CHARACTER_APPEARANCE_TIER_LEVELS.first, "mist-scholar": CHARACTER_APPEARANCE_TIER_LEVELS.second, "night-watch": CHARACTER_APPEARANCE_TIER_LEVELS.complete },
  relic: { none: CHARACTER_APPEARANCE_TIER_LEVELS.first, "jade-compass": CHARACTER_APPEARANCE_TIER_LEVELS.second, "star-token": CHARACTER_APPEARANCE_TIER_LEVELS.complete },
  scene: { "harbour-night": CHARACTER_APPEARANCE_TIER_LEVELS.first, "morning-mist": CHARACTER_APPEARANCE_TIER_LEVELS.second, "moon-passage": CHARACTER_APPEARANCE_TIER_LEVELS.complete },
} as const satisfies Record<CharacterAppearanceProgressionSlot, Record<string, number>>;

export const CHARACTER_APPEARANCE_DEFAULTS = {
  form: "harbour",
  hair: "portrait",
  robes: "coastal-blue",
  relic: "none",
  scene: "harbour-night",
} as const satisfies Record<CharacterAppearanceProgressionSlot, string>;

export const CHARACTER_PORTRAIT_BY_ROBES = {
  "coastal-blue": "show-coastal-blue",
  "mist-scholar": "show-mist-scholar",
  "night-watch": "show-night-watch",
} as const;

export function characterPortraitForRobes(robes: string) {
  return (CHARACTER_PORTRAIT_BY_ROBES as Record<string, string>)[robes] ?? CHARACTER_PORTRAIT_BY_ROBES["coastal-blue"];
}

export function characterAppearanceMinLevel(slot: CharacterAppearanceProgressionSlot, value: string) {
  return (CHARACTER_APPEARANCE_UNLOCK_LEVELS[slot] as Record<string, number>)[value] ?? Number.POSITIVE_INFINITY;
}

export function canUseCharacterAppearance(
  level: number,
  elevated: boolean,
  slot: CharacterAppearanceProgressionSlot,
  value: string,
) {
  return elevated || level >= characterAppearanceMinLevel(slot, value);
}

export function resetLockedCharacterAppearanceForMember(
  level: number,
  appearance: Record<CharacterAppearanceProgressionSlot, string>,
) {
  const next = { ...appearance };
  const resetSlots: CharacterAppearanceProgressionSlot[] = [];
  for (const slot of Object.keys(CHARACTER_APPEARANCE_DEFAULTS) as CharacterAppearanceProgressionSlot[]) {
    if (canUseCharacterAppearance(level, false, slot, next[slot])) continue;
    next[slot] = CHARACTER_APPEARANCE_DEFAULTS[slot];
    resetSlots.push(slot);
  }
  return { appearance: next, resetSlots };
}
